<script setup lang="ts">
import { computed, type Component } from 'vue';
import { DOCUMENT } from '@pkg/config/sanity/schemas';
import { type CmsIconName } from '@pkg/cms-icons';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    theme: string;
    anchorId?: string;
    vendorTypes: Array<{
      _id: string;
      _type: DOCUMENT.MARKETPLACES_VENDOR_TYPE;
      title: string;
      icon: CmsIconName;
    }>;
    stepOneTitle: string | null
    stepTwoTitle: string | null
    changeButtonText: string | null
    countryFieldTitle: string | null
    postcodeFieldTitle: string | null
    submitButtonText: string | null
  };
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  vendorTypes: props.block?.vendorTypes,
  stepOneTitle: props.block?.stepOneTitle,
  stepTwoTitle: props.block?.stepTwoTitle,
  changeButtonText: props.block?.changeButtonText,
  countryFieldTitle: props.block?.countryFieldTitle,
  postcodeFieldTitle: props.block?.postcodeFieldTitle,
  submitButtonText: props.block?.submitButtonText,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data"/>
</template>
